import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-experience-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './experience-section.component.html',
  styleUrl: './experience-section.component.css'
})
export class ExperienceSectionComponent {
  previews = [
    {
      label: 'Event Feed',
      desc: 'Discover parties happening near you',
      type: 'feed'
    },
    {
      label: 'Real-Time Chat',
      desc: 'Connect with hosts and attendees',
      type: 'chat'
    }
  ];
}
